(function (angular) {
    'use strict';

    angular.module('Common')

        /**
         *
         */
        .factory("jwtService", ['$http', 'portalConfig', '$q', '$cookies', 'growlService', '$timeout', '$rootScope', '$state', 'permissionService', '$sce', 'totpService',
            function ($http, portalConfig, $q, $cookies, growlService, $timeout, $rootScope, $state, permissionService, $sce, totpService) {

                var timer;

                function timeoutRefresh(arg) {

                    var refreshTimeoutMin = portalConfig.refreshTimeoutMin;
                    var retryTimeoutMin = 1;

                    if (arg === 'stop' && timer) {
                        $timeout.cancel(timer);
                    } else if (arg === 'start') {
                        var now = Date.now() / 1000 | 0;

                        if (fac.payload && fac.payload.exp && fac.payload.exp > now + refreshTimeoutMin * 60) {
                            timer = $timeout(fac.refresh, refreshTimeoutMin * 60000);
                        } else {
                            timer = $timeout(fac.refresh, 0);
                        }

                    } else if (arg === 'retry') {
                        timer = $timeout(fac.refresh, retryTimeoutMin * 60000);
                    }

                }

                var fac = {
                    /**
                     * The raw token
                     */
                    token: undefined,
                    /**
                     * The jwt header
                     */
                    header: undefined,
                    /**
                     * The jwt payload
                     */
                    payload: undefined,
                    /**
                     * The jwt signature
                     */
                    signature: undefined,

                    /**
                     * Function to parse a Json Web Token ino the above properties
                     * @param {String} jwt -  the Json Web Token
                     */
                    set: function (jwt, loginStatus) {
                        sessionStorage.setItem("jwt", jwt);
                        this.token = jwt;
                        var bits = this.token.split(".");

                        if (bits.length === 3) {
                            this.header = JSON.parse(atob(bits[0]));
                            this.payload = JSON.parse(atob(bits[1]));

                            $cookies.put("ecuserid", fac.payload.userId);

                            permissionService.buildTree(fac.payload.permissions);

                            if (loginStatus !== 'TotpAuthenticationRequired' && !permissionService.checkPrivilegeToDisplay('main.apiSpace')) {
                                this.clear();
                                growlService.danger("Access Denied. Please try another account, or contact support.");
                            }
                            this.signature = bits[2];
                        } else {
                            this.clear();
                        }
                        timeoutRefresh('start');
                    },

                    /**
                     *
                     */
                    clear: function () {
                        //
                        $cookies.remove("ecuserid");
                        this.token = this.header = this.payload = this.signature = undefined;
                        sessionStorage.removeItem("jwt");
                        $rootScope.$broadcast("jwtService.clear");
                        timeoutRefresh('stop');
                    },
                    /**
                     * Function to check expiry of
                     */
                    isValid: function () {

                        if (this.payload !== undefined) {
                            if (this.payload.exp !== undefined) {
                                var now = Date.now() / 1000 | 0;
                                return now < this.payload.exp;
                            } else {
                                return true;
                            }
                        } else {
                            return false;
                        }
                    },
                    /**
                     * Login
                     */
                    login: function (username, password, returnurl) {
                        var url = portalConfig.authUrlBase + "/authenticate";

                        function authenticateUser() {
                            return $http.post(url, {
                                userName: username,
                                password: password,
                            });
                        }

                        function loginFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                        return authenticateUser()
                            .then(function (response) {
                                var payload = {
                                    accountId: response.data.accountId,
                                    userId: response.data.userId,
                                    returnUrl: returnurl
                                }
                                fac.loginComplete(response);

                                if (response.data.status === "TotpAuthenticationRequired") {
                                    return totpService.isTotpActivated(payload).then(function (totpActiveResponse) {
                                        if (totpActiveResponse.result) {
                                            $state.go('totp', payload);
                                        }

                                        return response;
                                    });
                                }

                                return response;
                            })
                            .catch(loginFailed);
                    },
                    /**
                     *Login with token
                     */
                    loginComplete: function (response) {
                        var self = this;

                        self.set(response.data.token, response.data.status);
                        return response;
                    },
                    /**
                     *Login with token to SMS platform
                      This has to be a FORM browser based http call.
                     */
                    silentLogOnJwt: function (redirectUrl) {

                        const suffixes = [
                            "-cpaas.staging.dotdigital.com",
                            "-cpaas.dotdigital.com",
                            "-cpaas.dotdigital.internal"
                        ];

                        const isValidRedirectUrl = suffixes.some((suffix) =>
                            redirectUrl.includes(suffix)
                        );

                        if (isValidRedirectUrl) {
                            const urlObject = new URL(redirectUrl);
                            const baseUrl = `${urlObject.protocol}//${urlObject.host}/DD/Security/Login/SilentLogOnJwt`;
                            const wrappedApiUrl = $sce.trustAsResourceUrl(baseUrl);
                            const apiUrl = $sce.getTrustedResourceUrl(wrappedApiUrl);

                            const form = document.createElement("form");
                            form.setAttribute("method", "post");
                            form.setAttribute("action", apiUrl);
                            form.style.display = "none";

                            const jwtInput = document.createElement("input");
                            jwtInput.setAttribute("type", "hidden");
                            jwtInput.setAttribute("name", "jwt");
                            jwtInput.setAttribute("value", sessionStorage.getItem("jwt"));
                            form.appendChild(jwtInput);

                            const redirectUrlInput = document.createElement("input");
                            redirectUrlInput.setAttribute("type", "hidden");
                            redirectUrlInput.setAttribute("name", "redirectUrl");
                            redirectUrlInput.setAttribute("value", redirectUrl);
                            form.appendChild(redirectUrlInput);

                            document.body.appendChild(form);

                            form.submit();
                            document.body.removeChild(form);
                        }
                    },
                    /**
                     *Login with token
                     */
                    loginComplete: function (response) {
                        var self = this;

                        self.set(response.data.token, response.data.status);
                        return response;
                    },
                    /**
                     *Validate email
                    */
                    validateEmail: function (accountId, data) {
                        var self = this;
                        var url = portalConfig.urlBase;
                        return $http.post(url + "/accounts/" + accountId + "/email/completeverify", data)
                            .then(validationComplete)
                            .catch(validationFailed);

                        function validationComplete(response) {
                            return response;
                        }

                        function validationFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    },
                    /**
                     *refresh token
                    */
                    refresh: function () {
                        var self = this;
                        var url = portalConfig.authUrlBase + '/authenticate/refreshToken';
                        return $http.get(url, { async: true })
                            .then(refreshComplete)
                            .catch(refreshFailed);

                        function refreshComplete(response) {
                            fac.set(response.data.token, response.data.status);
                            $rootScope.$broadcast("jwtService.refresh", response.data.token);
                            return response;
                        }

                        function refreshFailed(error) {
                            var deferred = $q.defer();
                            if (error.status === 401) {
                                deferred.reject(error);
                            }
                            else {
                                deferred.resolve(error);
                                timeoutRefresh('retry');
                            }
                            return deferred.promise;
                        }
                    }

                };

                // get token out of local storage if there is one ...
                var cached = sessionStorage.getItem("jwt");

                if (cached !== null) {
                    fac.set(cached);

                    if (!fac.isValid()) {
                        fac.clear();
                    }
                }

                return fac;
            }]);



})(window.angular);
